/* "Buy on WhatsApp" (snippets/wg-whatsapp-buy.liquid)
   Keeps the prefilled message in sync with the selected variant:
   - product page: Dawn publishes `variant-change` after each option change
   - cards: the colour swatches set data-variant-id on click (wg-card-swatches.js)
   Everything needed is on the link's data attributes, no network calls. */
(() => {
  if (window.__wgWhatsappBuy) return;
  window.__wgWhatsappBuy = true;

  const buildHref = (link, variantId) => {
    const ids = (link.dataset.variants || '').split(',');
    const titles = (link.dataset.variantTitles || '').split('||');
    const prices = (link.dataset.variantPrices || '').split('||');
    const idx = ids.indexOf(String(variantId));
    if (idx < 0) return null;
    const isDefault = link.dataset.defaultVariant === '1';
    const variantPart = isDefault || !titles[idx] ? '' : ` – ${titles[idx]}`;
    const pricePart = prices[idx] ? ` (${prices[idx]})` : '';
    const url = `${link.dataset.productUrl}?variant=${ids[idx]}`;
    const message = (link.dataset.template || '')
      .replace('[[variant]]', variantPart)
      .replace('[[price]]', pricePart)
      .replace('[[url]]', url);
    return `https://wa.me/${link.dataset.number}?text=${encodeURIComponent(message)}`;
  };

  const update = (link, variantId) => {
    const href = buildHref(link, variantId);
    if (href) link.href = href;
  };

  // Product page: follow Dawn's variant change
  // PUB_SUB_EVENTS is a top-level const in constants.js, so check it by name, not on window
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const variant = data?.variant;
      if (!variant) return;
      const root = data.sectionId ? document.getElementById(`shopify-section-${data.sectionId}`) || document : document;
      root.querySelectorAll('[data-wg-wa-buy].wg-wa-buy--pdp, [data-wg-wa-buy].wg-wa-buy--sticky').forEach((link) => update(link, variant.id));
    });
  }

  // Safety net on click: read the form's current variant id (covers any flow that
  // changed the hidden input without publishing the event)
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-wg-wa-buy].wg-wa-buy--pdp, [data-wg-wa-buy].wg-wa-buy--sticky');
    if (!link) return;
    const input = (link.closest('product-info, .product') || document).querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input?.value) update(link, input.value);
  });

  // Cards: swatch clicks
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-wg-swatch]');
    if (!swatch) return;
    const card = swatch.closest('.wg-pc');
    const link = card?.querySelector('[data-wg-wa-buy]');
    if (link && swatch.dataset.variantId) update(link, swatch.dataset.variantId);
  });
})();
